/* eslint-disable vue/multi-word-component-names */

// #region Imports

import Vue from 'vue';

// #endregion

// #region Component Registration

Vue.component('DocumentUpload', () => import(/* webpackChunkName: "order-pages" */ '@/order/components/modal/DocumentUpload.vue'));

// #endregion
